module.exports = __webpack_public_path__ + "assets/img/news (23).0d73176b.png";